import React, { useEffect, useRef } from 'react';

import { Spinner } from '@infoods/lifebase-ui';

import classes from './NgzTrainingCalendar.module.scss';
import { angularizeWithProviders } from '../../../shared/providers';
import { useModalToggle } from '../../../shared/hooks/useModalToggle';
import { trainingCalendarLink } from '../../constants/externalLinks';

const NgzTrainingCalendar = () => {
  const [isShowSpinner, toggleIsShowSpinner] = useModalToggle(true);
  const iframeRef = useRef<HTMLIFrameElement>(null);

  useEffect(() => {
    if (iframeRef.current) {
      iframeRef.current.onload = toggleIsShowSpinner;
    }
  }, []);

  return (
    <div>
      <iframe
        ref={iframeRef}
        src={trainingCalendarLink}
        title="Training Calendar"
        className={classes.iframeContent}
      />
      <Spinner isLoading={isShowSpinner} isGlobal />
    </div>
  );
};

angularizeWithProviders(NgzTrainingCalendar, 'ngzTrainingCalendar', {});

export { NgzTrainingCalendar };
